import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../config";
import Popup from "../../../Popup";
import Table from "../../Table";
import { fetchMediums } from "../redux/mediumSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSubject, getSubjects, toggleSubjectStatus, updateSubjectMedium, deleteSubjectBoard } from "../../subject/redux/subjectThunk";
import showToast from "../../../utils/toast";
import { fetchChapters, linkChapterSub, fetchLinkedChapters } from "../redux/chapterSlice";
import { TableSkeleton } from "../Skeleton";
const Subject = () => {
  const dispatch = useDispatch();
  const { boardId } = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const [subjectName, setSubjectName] = useState("");
  const [page, setPage] = useState(1);
  const [editingSubject, setEditingSubject] = useState(null);
  const [limit] = useState(10);

  // COMMENTED OUT - Link functionality state variables
  // const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [selectedMediums, setSelectedMediums] = useState([]);
  // const [selectedChapters, setSelectedChapters] = useState([]);
  // const [LinkPopup, setLinkPopup] = useState(false);
  const availableMediums = useSelector((state) => state.mediums.list);
  // const sampleSubjects = useSelector((state) => state.subject.subjectsList);
  const { subjectsList, pagination, loading } = useSelector((state) => state.subject);
  // COMMENTED OUT - Chapters data for linking
  // const { items: chapters = [], loading } = useSelector(
  //   (state) => state.boardChapters || {},
  // );
  // const loading = useSelector((state) => state.boardChapters?.loading || false);

  //  useEffect(() => {
  //   if (boardId) {
  //     dispatch(fetchMediums(boardId));
  //     dispatch(getSubjects({ boardId, page, limit }));
  //   }
  // }, [dispatch, boardId, page]);
  useEffect(() => {
    if (boardId) {
      dispatch(fetchMediums(boardId));
      dispatch(getSubjects({ boardId, page, limit }));
    }
  }, [dispatch, boardId, page, limit]);





  // COMMENTED OUT - useEffect for link popup
  // useEffect(() => {
  //   if (LinkPopup && boardId) {
  //     dispatch(fetchChapters(boardId));
  //     dispatch(fetchLinkedChapters({ board_id: boardId, subject_id: selectedSubjectId }));
  //   }
  // }, [LinkPopup, boardId, dispatch]);

  const handleMediumChange = (mediumId) => {
    setSelectedMediums((prev) =>
      prev.includes(mediumId)
        ? prev.filter((id) => id !== mediumId)
        : [...prev, mediumId],
    );
  };

  // COMMENTED OUT - handleChapterChange
  // const handleChapterChange = (chapterId) => {
  //   setSelectedChapters((prev) =>
  //     prev.includes(chapterId)
  //       ? prev.filter((id) => id !== chapterId)
  //       : [...prev, chapterId],
  //   );
  // };

  // COMMENTED OUT - handleLinkSubmit
  // const handleLinkSubmit = () => {
  //   dispatch(
  //     linkChapterSub({
  //       board_id: boardId,
  //       subject_id: selectedSubjectId,
  //       chapter_ids: selectedChapters,
  //     }),
  //   ).then(() => {
  //     setLinkPopup(false);
  //   });
  // };
  // const handleSubmit = () => {
  //   const payload = {
  //     subject_name: subjectName,
  //     medium_ids: selectedMediums,
  //   };
  //   console.log("Submitted Subject Data 👉", payload);

  //   // Reset form
  //   setSubjectName("");
  //   setSelectedMediums([]);
  //   setShowPopup(false);
  // };

  const handleEdit = (row) => {
    setEditingSubject(row.subject_id || row.id); // or row.subject_id depending on API
    setSubjectName(row.subject_name);

    // convert medium names → ids
    if (row.medium_ids) {
      setSelectedMediums(row.medium_ids);
    }

    setShowPopup(true);
  };
  const handleSubmit = async () => {
    const payload = {
      subject_name: subjectName,
      board_id: Number(boardId),
      medium_ids: selectedMediums,
    };

    try {
      if (editingSubject) {
        await dispatch(updateSubjectMedium({ subjectId: editingSubject, payload })).unwrap();
      } else {
        await dispatch(createSubject(payload)).unwrap();
      }

      dispatch(getSubjects({ boardId, page, limit }));

      setSubjectName("");
      setSelectedMediums([]);
      setEditingSubject(null);
      setShowPopup(false);
    } catch (err) {
      console.error(editingSubject ? "Update subject failed" : "Create subject failed", err);
    }
  };

  const handleToggleStatus = (row) => {
    const subjectId = row.subject_id || row.id;
    const newStatus = row.status ? "Inactive" : "Active";
    if (window.confirm(`Are you sure you want to change the status of "${row.subject_name}" to ${newStatus}?`)) {
      dispatch(toggleSubjectStatus(subjectId)).then(() => {
        dispatch(getSubjects({ boardId, page, limit }));
      });
    }
  };

  const handleDelete = async (row) => {
    console.log("row", row)
    const subjectId = row.subject_id;
    if (!window.confirm(`Are you sure you want to delete "${row.subject_name}"?`)) return;
    try {
      await dispatch(deleteSubjectBoard(subjectId)).unwrap();
      showToast.success("Subject deleted successfully");
      dispatch(getSubjects({ boardId, page, limit }));
    } catch (error) {
      showToast.error(error);
    }
  };

  // const isFormValid = subjectName.trim() && selectedMediums.length > 0;
  const isFormValid = subjectName.trim() && (editingSubject || selectedMediums.length > 0);

  // Define table columns
  const columns = [
    {
      header: "Subject Name",
      accessor: "subject_name",
      align: "left",
    },
    {
      header: "Medium Name",
      accessor: "medium_names",
      align: "left",
    },
    {
      header: "Status",
      accessor: "status",
      align: "left",
      render: (status) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "500",
            backgroundColor: status ? "#d1fae5" : "#fee2e2",
            color: status ? "#065f46" : "#991b1b",
          }}
        >
          {status ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      header: "Actions",
      accessor: "status",
      align: "center",
      render: (status, row) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
          <i
            className="bi bi-pencil-square"
            style={{
              fontSize: "16px",
              color: "#3b82f6",
              cursor: "pointer",
            }}
            title="Edit"
            onClick={() => handleEdit(row)}
          />
          <i
            className="bi bi-trash"
            style={{
              fontSize: "16px",
              color: "#dc2626",
              cursor: "pointer",
            }}
            title="Delete"
            onClick={() => handleDelete(row)}
          />
          <div
            onClick={() => handleToggleStatus(row)}
            style={{
              display: "inline-block",
              width: "36px",
              height: "20px",
              borderRadius: "10px",
              backgroundColor: status ? "#22c55e" : "#d1d5db",
              position: "relative",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
            }}
          >
            <div
              style={{
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                backgroundColor: "white",
                position: "absolute",
                top: "3px",
                left: status ? "19px" : "3px",
                transition: "left 0.3s ease",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
              }}
            />
          </div>
        </div>
      ),
    },
    // {
    //   header: "Actions",
    //   accessor: "actions",
    //   align: "center",
    //   render: (_, row) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         gap: "16px",
    //         justifyContent: "center",
    //         alignItems: "center",
    //       }}
    //     >
    //       <i
    //         className="bi bi-pencil-square"
    //         style={{
    //           fontSize: "18px",
    //           color: "#3b82f6",
    //           cursor: "pointer",
    //         }}
    //         title="Edit"
    //         onClick={() => handleEdit(row)}
    //       />
    //       <i
    //         className="bi bi-trash"
    //         style={{
    //           fontSize: "18px",
    //           color: "#dc2626",
    //           cursor: "pointer",
    //         }}
    //         title="Delete"
    //       // onClick={() => handleDelete(row.chapter_id)}
    //       />
    //     </div>
    //   ),
    // },

    // COMMENTED OUT - Link button functionality temporarily disabled
    // {
    //   header: "Action",
    //   accessor: "id", // or any unique field
    //   align: "left",
    //   render: (id, row) => (
    //     <button
    //       onClick={() => handleLink(row)}
    //       style={{
    //         padding: "6px 12px",
    //         fontSize: "13px",
    //         borderRadius: "6px",
    //         border: "none",
    //         cursor: "pointer",
    //         backgroundColor: "#2563eb",
    //         color: "#fff",
    //       }}
    //     >
    //       Link
    //     </button>
    //   ),
    // },
  ];

  // COMMENTED OUT - Link handler function
  // const handleLink = (row) => {
  //   console.log("Linking chapters for subject ID:", row.subject_id);
  //   setLinkPopup(true);
  //   setSelectedSubjectId(row.subject_id);
  // };


  return (
    <div style={{ padding: "0", maxWidth: "100%", margin: "0 auto" }}>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: "600",
            color: "#1f2937",
          }}
        >
          Subjects
        </h2>
        <button
          onClick={() => setShowPopup(true)}
          style={{
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#2563eb")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#3b82f6")}
        >
          <span style={{ fontSize: "18px" }}>+</span> Add Subject
        </button>
      </div>

      {/* TABLE */}
      {loading ? (
        <TableSkeleton rows={5} columns={4} />
      ) : (
        <Table columns={columns} data={subjectsList} serialNumberOffset={(page - 1) * limit} />
      )}

      {pagination?.totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            marginTop: "30px",
            flexWrap: "wrap",
          }}
        >

          {/* PREVIOUS */}
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              background:
                page === 1
                  ? "#e5e7eb"
                  : "linear-gradient(135deg, #6366f1, #3b82f6)",
              color: page === 1 ? "#9ca3af" : "white",
              cursor: page === 1 ? "not-allowed" : "pointer",
              boxShadow:
                page === 1
                  ? "none"
                  : "0 4px 10px rgba(59, 130, 246, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            ‹
          </button>

          {/* PAGE NUMBERS */}
          {Array.from(
            { length: pagination?.totalPages || 1 },
            (_, i) => i + 1
          )
            .slice(
              Math.max(0, page - 3),
              Math.min(pagination?.totalPages || 1, page + 2)
            )
            .map((pageNumber) => (
              <button
                key={pageNumber}
                onClick={() => setPage(pageNumber)}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  border: "none",
                  background:
                    pageNumber === page
                      ? "linear-gradient(135deg, #ec4899, #f43f5e)"
                      : "#f3f4f6",
                  color: pageNumber === page ? "white" : "#374151",
                  fontWeight: "600",
                  cursor: "pointer",
                  boxShadow:
                    pageNumber === page
                      ? "0 4px 12px rgba(244, 63, 94, 0.4)"
                      : "0 2px 6px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                }}
              >
                {pageNumber}
              </button>
            ))}

          {/* NEXT */}
          <button
            disabled={page === pagination?.totalPages}
            onClick={() => setPage(page + 1)}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              background:
                page === pagination?.totalPages
                  ? "#e5e7eb"
                  : "linear-gradient(135deg, #6366f1, #3b82f6)",
              color:
                page === pagination?.totalPages ? "#9ca3af" : "white",
              cursor:
                page === pagination?.totalPages
                  ? "not-allowed"
                  : "pointer",
              boxShadow:
                page === pagination?.totalPages
                  ? "none"
                  : "0 4px 10px rgba(59, 130, 246, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            ›
          </button>
        </div>
      )}
      {/* POPUP */}
      {showPopup && (
        <Popup
          onClose={() => setShowPopup(false)}
          title={editingSubject ? "Edit Subject" : "Add New Subject"}
          maxWidth="400px"
        >
          {/* SUBJECT NAME */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Subject Name <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="text"
              value={subjectName}
              onChange={(e) => setSubjectName(e.target.value)}
              placeholder="Enter subject name"
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                fontSize: "14px",
                color: "#111827",
                outline: "none",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
            />
          </div>

          {/* MEDIUMS CHECKBOXES */}
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "12px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Select Mediums <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "12px",
                padding: "12px",
                border: "1px solid #e5e7eb",
                borderRadius: "6px",
                backgroundColor: "#f9fafb",
              }}
            >
              {availableMediums.map((medium) => (
                <label
                  key={medium.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#374151",
                    padding: "6px",
                    borderRadius: "4px",
                    transition: "background-color 0.15s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#e5e7eb")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "transparent")
                  }
                >
                  <input
                    type="checkbox"
                    checked={selectedMediums.includes(medium.id)}
                    onChange={() => handleMediumChange(medium.id)}
                    style={{
                      marginRight: "8px",
                      cursor: "pointer",
                      width: "16px",
                      height: "16px",
                    }}
                  />
                  {medium.name}
                </label>
              ))}
            </div>
          </div>

          {/* ACTIONS */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              paddingTop: "16px",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <button
              onClick={() => {
                setShowPopup(false);
                setSubjectName("");
                setSelectedMediums([]);
                setEditingSubject(null);
              }}
              style={{
                padding: "10px 20px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
                backgroundColor: "white",
                cursor: "pointer",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#f9fafb")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "white")}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={!isFormValid}
              style={{
                padding: "10px 20px",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                color: "white",
                backgroundColor: isFormValid ? "#3b82f6" : "#9ca3af",
                cursor: isFormValid ? "pointer" : "not-allowed",
                transition: "background-color 0.2s",
              }}
              onMouseOver={(e) => {
                if (isFormValid) e.target.style.backgroundColor = "#2563eb";
              }}
              onMouseOut={(e) => {
                if (isFormValid) e.target.style.backgroundColor = "#3b82f6";
              }}
            >
              {editingSubject ? "Update Subject" : "Save Subject"}
            </button>
          </div>
        </Popup>
      )}

      {/* COMMENTED OUT - Link Chapters Popup */}
      {/* {LinkPopup && (
        <Popup
          onClose={() => setLinkPopup(false)}
          title="Link Chapters"
          maxWidth="400px"
        >
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "12px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              Select Chapters <span style={{ color: "#dc2626" }}>*</span>
            </label>

            {loading ? (
              <p style={{ fontSize: "13px", color: "#6b7280" }}>
                Loading chapters...
              </p>
            ) : chapters.length > 0 ? (
              <div
                style={{
                  maxHeight: "220px",
                  overflowY: "auto",
                  padding: "12px",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  backgroundColor: "#f9fafb",
                }}
              >
                {chapters.map((chapter) => (
                  <label
                    key={chapter.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "6px",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#374151",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedChapters.includes(chapter.id)}
                      onChange={() => handleChapterChange(chapter.id)}
                    />
                    {chapter.name}
                  </label>
                ))}
              </div>
            ) : (
              <p style={{ fontSize: "13px", color: "#6b7280" }}>
                No chapters found
              </p>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              paddingTop: "16px",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <button
              onClick={() => setLinkPopup(false)}
              style={{
                padding: "8px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                backgroundColor: "white",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>

            <button
              onClick={handleLinkSubmit}
              disabled={selectedChapters.length === 0}
              style={{
                padding: "8px 16px",
                border: "none",
                borderRadius: "6px",
                backgroundColor:
                  selectedChapters.length > 0 ? "#3b82f6" : "#9ca3af",
                color: "white",
                cursor: selectedChapters.length > 0 ? "pointer" : "not-allowed",
              }}
            >
              Save
            </button>
          </div>
        </Popup>
      )} */}
    </div>
  );
};

export default Subject;
